import client from '../../../../apollo';
import { gql } from '@apollo/client'

export const ORGANIZATION_STATISTICS_FETCH_FAIL = 'ORGANIZATION_STATISTICS_FETCH_FAIL';
export const ORGANIZATION_STATISTICS_FETCH_INIT = 'ORGANIZATION_STATISTICS_FETCH_INIT';
export const ORGANIZATION_STATISTICS_FETCH_SUCCESS = 'ORGANIZATION_STATISTICS_FETCH_SUCCESS';

const initialState = {
  data: {
    statistics: {},
    user: {}
  },
  error: '',
  loading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ORGANIZATION_STATISTICS_FETCH_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case ORGANIZATION_STATISTICS_FETCH_INIT:
      return {
        ...state,
        loading: true
      };
    case ORGANIZATION_STATISTICS_FETCH_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false
      };
    default:
      return state;
  }
}

const orgStatisticsQuery = gql`
  query orgStatistics {
    user {
      firstName
      id
    }
    statistics {
      orgCounts {
        employees
        jobs
        salaryRanges
      }
      surveyYear
    }
  }
`;

export const actions = {};

actions.getOrganizationStatistics = async function getOrganizationStatistics(dispatch) {
  dispatch({ type: ORGANIZATION_STATISTICS_FETCH_INIT });
  try {
    const response = await client.query({
      query: orgStatisticsQuery,
      fetchPolicy: 'network-only'
    });
    dispatch({
      type: ORGANIZATION_STATISTICS_FETCH_SUCCESS,
      data: response.data
    });
  } catch (error) {
    dispatch({
      type: ORGANIZATION_STATISTICS_FETCH_FAIL,
      error: error.message
    });
    console.log(error);
  }
};
